module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regbox",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("公司全称")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "18",
      "placeholder": "请填写您公司的名称"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "blur": _vm.nameBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("公司简称")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortName),
      expression: "shortName"
    }],
    attrs: {
      "type": "text",
      "maxlength": "8",
      "placeholder": "请输入您公司的简称"
    },
    domProps: {
      "value": (_vm.shortName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shortName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("公司固话")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    attrs: {
      "maxlength": "18",
      "type": "text",
      "placeholder": "请输入您公司的联系方式"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "other"
  }, [_vm._v("如0571-888888")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("您的姓名")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adminName),
      expression: "adminName"
    }],
    attrs: {
      "maxlength": "11",
      "type": "text",
      "placeholder": "请输入您的姓名"
    },
    domProps: {
      "value": (_vm.adminName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adminName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("行业类型")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择行业类型"
    },
    model: {
      value: (_vm.industry),
      callback: function($$v) {
        _vm.industry = $$v
      },
      expression: "industry"
    }
  }, _vm._l((_vm.listIndustry), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.id + '/' + item.name
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("logo")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-upload', {
    staticClass: "uploader",
    attrs: {
      "action": "/wapi/base/upload/logo",
      "name": "logoFile",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [(_vm.logoUrl) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl
    }
  }) : _c('div', {
    staticClass: "upload-tips"
  }, [_vm._v("点击上传")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("全景大图")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-upload', {
    staticClass: "uploader background-upload",
    attrs: {
      "action": "/wapi/base/upload/backgroundImg",
      "name": "backgroundImageFile",
      "show-file-list": false,
      "on-success": _vm.handleBackSuccess
    }
  }, [(_vm.backgroundUrl) ? _c('img', {
    attrs: {
      "src": _vm.backgroundUrl
    }
  }) : _c('div', {
    staticClass: "upload-tips"
  }, [_vm._v("点击上传")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("工厂规模")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择规模"
    },
    model: {
      value: (_vm.scale),
      callback: function($$v) {
        _vm.scale = $$v
      },
      expression: "scale"
    }
  }, _vm._l((_vm.listScale), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("所属区县")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.provinceArr
    },
    on: {
      "active-item-change": _vm.handleItemChange
    },
    model: {
      value: (_vm.selectOptions),
      callback: function($$v) {
        _vm.selectOptions = $$v
      },
      expression: "selectOptions"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("工厂地址")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "input-box m-b-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入详细地址"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('TxMap', {
    ref: "TxMap",
    on: {
      "updateAddress": _vm.updateAddress
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item m-b-20"
  }, [_c('div', {
    staticClass: "label reg-must"
  }, [_vm._v("工厂简介：")]), _vm._v(" "), _c('div', {
    staticClass: "value textarea-box"
  }, [_c('el-input', {
    attrs: {
      "max": "300",
      "type": "textarea",
      "placeholder": "请输入300字内的文本信息",
      "resize": "none"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.gostep
    }
  }, [_vm._v("下一步")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ebc29d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/create.vue
// module id = 870
// module chunks = 1